export function findById (array, id) {
  return array.find(item => item.id === id)
}

export function findByKeyValue (array, key, value) {
  return array.find(item => item[key] === value)
}
